import { useState } from 'react';

import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

import {
  Box,
  Button,
  Checkbox,
  DialogActions,
  FormControlLabel,
  Typography
} from '@mui/material';

import Dialog from '../Dialog';
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';

import { useSaveDutyLineForAbsenceMutation } from './queries';

type ErrorResponse = {
  error: {
    code: number;
    message: string;
  };
};

const CreateDutyForAbsenceDialog = ({ duty, onClose, isWithoutRequest }) => {
  const { t } = useTranslation();
  const [keepAbsence, setKeepAbsence] = useState<boolean>(false);

  const { mutate: saveDutyLine } = useSaveDutyLineForAbsenceMutation();

  const onClickSave = async () => {
    saveDutyLine(
      {
        duty,
        deleteAbsences: !keepAbsence,
        isWithoutRequest
      },
      {
        onSuccess: (response) => {
          if (response) {
            const { data } = response;
            if (data.errors && data.errors.length) {
              showErrorSnackbar();
            } else {
              showSuccessSnackbar();
              onClose(data);
            }
          }
        },
        onError: (error) => {
          const { response } = error as AxiosError<ErrorResponse>;
          showErrorSnackbar(response?.data?.error?.message ?? '');
        }
      }
    );
  };

  return (
    <Dialog
      open={true}
      handleClose={onClose}
      title={t('createDutyForAbsence.title')}
    >
      <Box p={2}>
        <Typography variant="body2">
          {t('createDutyForAbsence.description')}
        </Typography>
      </Box>
      <Box p={2}>
        <FormControlLabel
          disableTypography
          sx={{ fontSize: '13px' }}
          control={
            <Checkbox
              checked={keepAbsence}
              onChange={(evt, checked) => setKeepAbsence(checked)}
            />
          }
          label={t('createDutyForAbsence.keepAbsence') as string}
        />
      </Box>
      <DialogActions>
        <Button onClick={() => onClose()} color="secondary" variant="contained">
          {t('cancel')}
        </Button>
        <Button onClick={onClickSave} color="primary" variant="contained">
          {t('save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateDutyForAbsenceDialog;
